import { Phone, Camera } from "lucide-react";

export default function StickyMobileBar({ onStart, hidden }) {
  if (hidden) return null;
  return (
    <div
      data-testid="sticky-mobile-bar"
      className="fixed inset-x-0 bottom-0 z-40 flex gap-2 border-t border-charcoal/10 bg-white/90 p-3 backdrop-blur-md md:hidden"
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
    >
      <a
        href="tel:+16177179852"
        data-testid="sticky-call-btn"
        className="flex flex-1 items-center justify-center gap-2 rounded-full bg-charcoal px-4 py-3.5 text-sm font-semibold text-white"
      >
        <Phone size={16} /> Call now
      </a>
      <button
        onClick={onStart}
        data-testid="sticky-quote-btn"
        className="flex flex-1 items-center justify-center gap-2 rounded-full bg-violet px-4 py-3.5 text-sm font-semibold text-white"
      >
        <Camera size={16} /> Photo quote
      </button>
    </div>
  );
}
